/**
 * Heading for the headline slot on a /downloads product card.
 *
 * The slot carries the newest STABLE release, and only falls back to a
 * non-stable one when the product has no stable release at all (see the
 * selection loop in DownloadsPage). In that fallback case the heading may not
 * say "Stable": a customer looking at a card reading STABLE / v1.1.0 / [beta]
 * has to reconcile the heading against the chip, and the honest reading is the
 * chip. So the heading states what the slot actually holds — the latest release
 * — and the chip goes on saying which channel it came from.
 *
 * Pure so it can be tested without a DOM (this app has no jsdom/RTL harness).
 */
export function releaseSlotHeading(channel: string): string {
  return channel === 'stable' ? 'Stable' : 'Latest';
}
